import { render, staticRenderFns } from "./IncomeList.vue?vue&type=template&id=2a8977ce&scoped=true"
import script from "./IncomeList.vue?vue&type=script&lang=js"
export * from "./IncomeList.vue?vue&type=script&lang=js"
import style0 from "./IncomeList.vue?vue&type=style&index=0&id=2a8977ce&prod&lang=css&scoped=true"
import style1 from "./IncomeList.vue?vue&type=style&index=1&id=2a8977ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8977ce",
  null
  
)

export default component.exports